import { FC, lazy } from 'react';

const PasswordResetPageDefaultView = lazy(
  () => import('./default-view/PasswordResetPageDefaultView'),
);

export const PasswordResetPage: FC = () => <PasswordResetPageDefaultView />;
